// Header.tsx
import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, NavLink, useLocation, useMatch, useResolvedPath } from 'react-router-dom';

const Header: React.FC = () => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    setIsExpanded(false);
  }, [location.pathname]);

  return (
    <Navbar
      bg="primary"
      variant="dark"
      expand="lg"
      expanded={isExpanded}
      onToggle={(nextExpanded) => setIsExpanded(Boolean(nextExpanded))}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" onClick={() => setIsExpanded(false)}>
            <img className="badminton-logo" src="/assets/cock_riders_logo.png" alt="Logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar-nav" />
        <Navbar.Collapse id="main-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Item>
              <CustomNavLink to="/cost-calculation" label="Cost" onNavigate={() => setIsExpanded(false)} />
            </Nav.Item>
            <Nav.Item>
              <CustomNavLink to="/badminton-schedule" label="Schedule" onNavigate={() => setIsExpanded(false)} />
            </Nav.Item>
            <Nav.Item>
              <CustomNavLink to="/schedule-card" label="Card" onNavigate={() => setIsExpanded(false)} />
            </Nav.Item>
            <Nav.Item>
              <CustomNavLink to="/cock" label="Cock" onNavigate={() => setIsExpanded(false)} />
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

const CustomNavLink = ({ to, label, onNavigate }: { to: string, label: string, onNavigate?: () => void }) => {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: true });

  return (
    <NavLink 
      to={to}
      className={match ? "nav-link active" : "nav-link"}
      onClick={onNavigate}
    >
      {label}
    </NavLink>
  );
};

export default Header;
